import { ReactNode } from "react";
import { type AlertProps } from "./alert";
import { TailwindColors } from "@components/common/types/general";
import { Check } from "../icons/check";
import { WarningAlt } from "../icons/warning-alt";
import { InfoAlt } from "../icons/info-alt";

export function getIconByType(type: AlertProps["type"]): ReactNode {
    if (type === "info") return <InfoAlt />;
    if (type === "success") return <Check />;
    return <WarningAlt />;
}

export function getComponentColorProp(color: AlertProps["color"]): keyof TailwindColors | undefined {
    if (color === undefined) return "white";
    if (color === "white") return undefined;
    return color;
}
